import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-input-submit',
  templateUrl: './input-submit.component.html',
  styleUrls: ['./input-submit.component.scss']
})
export class InputSubmitComponent {
  @Input() type = 'submit';
  @Input() disabled: boolean;
  @Input() inputText: string;
  @Input() isLoading = false;
  @Input() isDanger = false;
  @Input() isSuccess = false;
  @Input() isLeft = false;
  @Input() isInverted = false;
  @Input() isOutlined = false;
  @Input() isWhite = false;
  @Input() isFullWidth = false;
  @Input() isNarrow = false;

  @Output() clickButton = new EventEmitter();
}
